import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useAlert } from 'react-alert';

const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DialogStyle = styled.div`
  width: 500px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  position: relative;
`;

const Title = styled.div`
  font-size: 20px;
  margin-bottom: 18px;
`;

const FormRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  gap: 16px;
`;

const Label = styled.label`
  width: 100px;
  text-align: left;
`;

const InputField = styled.input`
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  gap: 30px;
`;

const Button = styled.button`
  width: 90px;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  background-color: #649cdf;
  color: #fff;
  box-shadow: 1px 1px 3px 0 rgba(0,0,0,0.4), inset 0 2px 0 0 rgba(255,255,255,0.4);

  &:hover {
    background-color: #4682c4;
    box-shadow: 1px 1px 3px 0 rgba(0,0,0,0.4), inset 0 2px 0 0 rgba(255,255,255,0.4);
  }

  &.clear-btn {
    background-color: #979797;
    box-shadow: 1px 1px 3px 0 rgba(0,0,0,0.4), inset 0 2px 0 0 rgba(255,255,255,0.4);
  }
  &.clear-btn:hover {
    background-color: #858585;
  }
`;

const RegistrationDialog = ({ onClose, onRegister }) => {
  const [formData, setFormData] = useState({
    id: '',
    areaName: '',
    areaKana: '',
    color: '',
    sort: '',
    mogiriNumber: '',
  });
  const alert = useAlert();

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleRegister = async () => {
    const { id, areaName, areaKana, color, sort, mogiriNumber } = formData;


    if (!id || !areaName || !areaKana) {
      alert.error('エリアID、エリア名、エリア名カナを入力してください。');
      return;
    }
    try {
      const dataToRegister = {
        ...formData,
        baseId: 2, // baseIdを固定
      };
      console.log('Registering Data:', dataToRegister);
      // 登録処理を呼び出し
      await onRegister(dataToRegister);
      onClose(); // ダイアログを閉じる
    } catch (error) {
      console.error('登録処理中にエラーが発生しました:', error);
    }
  };

  const handleClearAll = () => {
    setFormData({
      id: '',
      areaName: '',
      areaKana: '',
      color: '',
      sort: '',
      mogiriNumber: '',
    });
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <DialogOverlay onClick={handleOverlayClick}>
      <DialogStyle>
        <Title><h2>新規登録</h2></Title>
        <div>
          <FormRow>
            <Label htmlFor="id">エリアID</Label>
            <InputField
              type="number"
              id="id"
              value={formData.id}
              onChange={handleInputChange}
            />
          </FormRow>
          <FormRow>
            <Label htmlFor="areaName">エリア名</Label>
            <InputField
              type="text"
              id="areaName"
              value={formData.areaName}
              onChange={handleInputChange}
            />
          </FormRow>
          <FormRow>
            <Label htmlFor="areaKana">エリア名カナ</Label>
            <InputField
              type="text"
              id="areaKana"
              value={formData.areaKana}
              onChange={handleInputChange}
            />
          </FormRow>
          <FormRow>
            <Label htmlFor="mogiriNumber">もぎり番号</Label>
            <InputField
              type="text"
              id="mogiriNumber"
              value={formData.mogiriNumber}
              onChange={handleInputChange}
            />
          </FormRow>
          <FormRow>
            <Label htmlFor="color">エリアカラー</Label>
            <InputField
              type="text"
              id="color"
              value={formData.color}
              onChange={handleInputChange}
            />
          </FormRow>
          <FormRow>
            <Label htmlFor="sort">ソート番号</Label>
            <InputField
              type="number"
              id="sort"
              value={formData.sort}
              onChange={handleInputChange}
            />
          </FormRow>
        </div>
        <ButtonContainer>
          <Button className="clear-btn" onClick={handleClearAll}>クリア</Button>
          <Button onClick={handleRegister}>登録</Button>
        </ButtonContainer>
      </DialogStyle>
    </DialogOverlay>
  );
};

RegistrationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onRegister: PropTypes.func.isRequired,
};

export default RegistrationDialog;